import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';
import MovieService from "@/apiServices/MovieService";

function initialState() {
  return {
    filterTabs: [],
    allMovieList: []
  };
};
const state = initialState();

const mutations = {
  ON_RESET_MOVIE_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  ON_SET_MOVIE_FILTER_TABS: (state, payload) => {
    state.filterTabs = payload
  },
  ON_SET_ALL_MOVIE_LIST: (state, payload) => {
    state.allMovieList = payload
  }
};

const actions = {
  onResetMovieStoreState: async ({
    dispatch, commit, state }, { ...payload }) => {
    await commit('ON_RESET_MOVIE_STORE_STATE');
  },
  onGetMovieList: async ({
    dispatch,
    commit,
    state
  }, payload) => {
    await commit('ON_SET_ALL_MOVIE_LIST', [])
    await commit('ON_SET_MOVIE_FILTER_TABS', [])
    // start Loader
    MovieService.GetMovies(payload)
      .then((response) => {
        const { data } = response
        console.log('data :>> ', data);
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        //   stop Loader
      });
  },
  onGetMovieByCode: async ({ dispatch, commit, state }, payload) => {
    await commit('ON_SET_ALL_MOVIE_LIST', [])
    await commit('ON_SET_MOVIE_FILTER_TABS', [])
    // start Loader
    MovieService.GetMovieByCode(payload)
      .then(response => {
        const { data } = response
        commit('ON_SET_ALL_MOVIE_LIST', data)
      }).catch(error => {
        console.log('error :>> ', error);
      }).finally(() => {
        //   stop Loader
      });
  },
  onGetHomepageMovies: async ({ dispatch, commit, state }, payload) => {
    await commit('ON_SET_ALL_MOVIE_LIST', [])
    await commit('ON_SET_MOVIE_FILTER_TABS', [])
    // start Loader
    MovieService.GetHomepageMovies(payload)
      .then(response => {
        const { data } = response
        commit('ON_SET_ALL_MOVIE_LIST', data.data)
      }).catch(error => {
        console.log('error :>> ', error);
      }).finally(() => {
        //   stop Loader
      });
  },
  onGetMoviesByCinema: async ({ dispatch, commit, state }, payload) => {
    await commit('ON_SET_ALL_MOVIE_LIST', [])
    await commit('ON_SET_MOVIE_FILTER_TABS', [])
    // start Loader
    MovieService.GetMoviesByCinema(payload)
      .then(response => {
        const { data } = response
        commit('ON_SET_ALL_MOVIE_LIST', data)
      }).catch(error => {
        console.log('error :>> ', error);
      }).finally(() => {
        //   stop Loader
      });
  },
  onSearchMovies: async ({ dispatch, commit, state }, payload) => {
    await commit('ON_SET_ALL_MOVIE_LIST', [])
    await commit('ON_SET_MOVIE_FILTER_TABS', [])
    // start Loader
    MovieService.SearchMovies(payload)
      .then(response => {
        const { data } = response
        commit('ON_SET_ALL_MOVIE_LIST', data)
      }).catch(error => {
        console.log('error :>> ', error);
      }).finally(() => {
        //   stop Loader
      });
  }
};

const getters = {
  getAllMovieList: state => state.allMovieList,
  getMovieFilterTabs: state => state.filterTabs
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/MovieStore.js